import React from "react";
import VideoPlayer from "../components/VideoPlayer";
import chunk from "lodash/chunk";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../utils/auth";  

const SeasonSection = ({ seasonTitle, description,seasonName, episodes }) => {
  const episodeRows = chunk(episodes, 2);
  const navigate = useNavigate();
  const { user } = useAuth();
  const handleWatchClick = () => {
    if (!user) {
      // Not logged in
      navigate("/login");
    } else if (user.plan_status === "ACTIVE") {
      // User is subscribed
      navigate(`/${seasonName}`);

    } else {
      // Logged in but not subscribed
      navigate("/membership-plan");
    }
  };

  return (
    <div id="explore" className="relative p-10 bg-white">
      <section className="px-6">
        <h2 className="text-4xl text-left font-bold text-black font-['EB_Garamond','Nunito','sans-serif']">
          {seasonTitle}
        </h2>
        <h3 className="text-2xl text-left mt-2 text-black font-semibold py-12">
          {description.title}
        </h3>
        <h3 className="text-lg text-left mt-2 text-black font-semibold pb-5">
          {description.subtitle}
        </h3>
        
      </section>

      <section className="w-full space-y-12">
  {episodeRows.map((row, rowIndex) => (
    <div
      key={rowIndex}
      className="grid grid-cols-1 md:grid-cols-2 w-full h-full relative gap-y-8"
    >
      {row.map((episode, index) => (
        <section
          key={index}
          className={`flex flex-col justify-start px-6 md:px-16 relative`}
        >
          <div className={`item-center relative h-[300px]`}>  
          <VideoPlayer
            url={episode.videoUrl}
            thumbnail={episode.thumbnail}
          />
          </div>
          <div className="mt-2">
            <h2 className="text-bold font-['EB_Garamond','Nunito','sans-serif'] font-bold">
              {episode.title}
            </h2>
            <h2 className="font-bold mt-1">{episode.subtitle}</h2>
            {episode.details && (
              <p className="text-lg text-left mt-2 text-black text-justify">
                {episode.details}
              </p>
            )}
            <button 
            onClick={handleWatchClick}
            className="mt-2 font-bold text-[rgb(234,126,93)] relative hover:bg-[rgb(234,126,93)] hover:text-white px-4 py-2 transition duration-300 after:content-[''] after:block after:h-[2px] after:w-full after:bg-[rgb(234,126,93)] after:mt-1">
              WATCH FULL EPISODE
            </button>
          </div>

          {/* Vertical line only for first column */}
          {index === 0 && (
            <div className="hidden md:block absolute right-0 top-0 h-full w-0.5 bg-[rgb(234,126,93)]"></div>
          )}
        </section>
      ))}
    </div>
  ))}
</section>
    </div>
  );
};

export default SeasonSection;
